import { Text, TextProps } from '@vimeo/bokeh';

export const TruncateTextWrapper = ({ ...props }: TextProps) => (
  <Text
    fontSize="14px"
    fontWeight="700"
    whiteSpace="normal"
    textAlign="left"
    variant="body-xl"
    css={`
      display: -webkit-box;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    `}
    {...props}
  />
);

export const Description = ({ ...props }: TextProps) => (
  <Text
    color="text-primary"
    fontSize="14px"
    fontStyle="normal"
    fontWeight="400"
    whiteSpace="pre-wrap"
    variant="body-xl"
    {...props}
  />
);
